/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/* eslint-disable @angular-eslint/component-selector */
import { Component, computed, HostBinding, inject, input } from '@angular/core';

import { MovieSiteConfigurationService } from '../movie-site-configuration.service';
import { MovieSiteNavActionComponent } from '../nav-action/movie-site-nav-action.component';
import { NavAction } from '../nav-action/movie-site-nav-action.model';
import { MovieSiteNavActionService } from '../nav-action/movie-site-nav-action.service';

@Component({
  selector: 'movie-site-landing-menu',
  standalone: true,
  imports: [MovieSiteNavActionComponent],
  templateUrl: './movie-site-landing-menu.component.html',
  styleUrls: ['./movie-site-landing-menu.component.scss']
})
export class MovieSiteMenuLandingComponent {
  private readonly configService = inject(MovieSiteConfigurationService);
  private readonly navActionService = inject(MovieSiteNavActionService);

  navActions = input.required<NavAction[]>();
  configuredNavActions = computed(() =>
    this.navActionService.insertCustomNavigationButton(
      this.navActions(),
      this.configService.customNavigationButtonConfiguration()
    )
  );
  /**
   * Used in the landing component when there is no gradient.
   * It will display the text with a fixed color (white) and shadows.
   * If **TRUE** it will be used WHEN **required**, check CSS of `movie-site-nav-action.component`.
   */
  fixedColor = input<boolean>(false);

  @HostBinding('class.fixed-color')
  get isFixedColor() {
    return this.fixedColor();
  }
}
